import { render, staticRenderFns } from "./phase.vue?vue&type=template&id=448071e9"
import script from "./phase.vue?vue&type=script&lang=js"
export * from "./phase.vue?vue&type=script&lang=js"
import style0 from "./phase.vue?vue&type=style&index=0&id=448071e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports